import{jsx as $}from"react/jsx-runtime";import o,{css as t}from"styled-components";import{mq as u}from"../../shared/media-queries.js";const n=t`
  font-feature-settings: 'lnum' on;
`,a=t`
  font-family: ${({theme:e})=>e.typography.fontBaseFamily};
  ${n}
`,i=t`
  ${a}
  font-weight: ${({theme:e})=>e.typography.fontBaseRegularWeight};
`,r=t`
  ${a}
  font-weight: ${({theme:e})=>e.typography.fontBaseBoldWeight};
`,m=t`
  ${i}
  font-size: 1rem;
  line-height: 1.5rem;
`,f=t`
  ${i}
  font-size: 0.75rem;
  line-height: 1.5rem;
`,h=t`
  ${i}
  font-size: 0.625rem;
  line-height: 1rem;
`,B=o.p`
  ${i}
`,p=t`
  font-family: Georgia, Cambria, Cochin, Times, 'Times New Roman', serif;
  font-style: italic;
  font-weight: ${({theme:e})=>e.typography.fontBaseRegularWeight};
  font-size: 1rem;
  line-height: 1.5rem;
  ${n}
`,d=o.p`
  ${p}
`,S=o.p`
  ${m}
`,l=t`
  ${r}
  font-size: 1rem;
  line-height: 1.5rem;
`,z=o.p`
  ${l}
`,C=o.p`
  ${f}
`,x=o.p`
  ${h}
`,s=t`
  ${r}
  font-size: 0.75rem;
  line-height: 1.5rem;
`,c=o.p`
  ${s}
`,y=t`
  font-family: ${({theme:e})=>e.typography.fontAlternativeFamily};
  font-weight: ${({theme:e})=>e.typography.fontAlternativeBoldWeight};
  font-size: 1rem;
  line-height: 1.5rem;
  text-transform: uppercase;
  font-feature-settings: 'lnum' on;

  ${u("laptop")} {
    font-size: 0.75rem;
  }
`,T=o.p`
  ${y}
`,g=()=>$("div",{});export{z as BodyLink,l as BodyLinkStyle,S as BodyText,m as BodyTextStyle,g as BodyTexts,C as Caption,x as Caption2,h as Caption2Style,c as CaptionLink,s as CaptionLinkStyle,f as CaptionStyle,d as Quote,p as QuoteStyle,T as Status,y as StatusStyle,B as StyledBodyText,g as default};
